export default [
    {
        title: 'Components',
        icon: 'ArchiveIcon',
        tagVariant: 'light-warning',
        route: 'components',
    },
]  